const i18nService = {
  defaultLanguage: "bg",

  languages: [
    {
      lang: "bg",
      name: "Български",
      flag: process.env.BASE_URL + "assets/media/flags/168-bulgaria.svg"
    },
    {
      lang: "en",
      name: "English",
      flag: process.env.BASE_URL + "assets/media/flags/226-united-states.svg"
    }
  ],

  /**
   * Keep the active language in the localStorage
   * @param lang
   */
  setActiveLanguage(lang) {
    localStorage.setItem("language", lang);
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage() {
    return localStorage.getItem("language") || this.defaultLanguage;
  }
};

export default i18nService;
